export default __webpack_public_path__ + "assets/images/907ec67e9cb22eb0ceebf5a312d94e51.svg";